var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wv-cell-swipe',{attrs:{"title":"是否绑定","value":_vm.wechatstate}}),_vm._v(" "),_c('div',{staticClass:"weui-cell"},[_c('wv-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.btnSave()}}},[_vm._v("解绑")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6934b0a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/set/setlock.vue
// module id = vDeK
// module chunks = 5